import script from "./AttachFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttachFile.vue?vue&type=script&lang=ts&setup=true"

import "./AttachFile.vue?vue&type=style&index=0&id=becb96b4&lang=scss&scoped=true"
import "./AttachFile.vue?vue&type=style&index=1&id=becb96b4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-becb96b4"]])

export default __exports__